import React from 'react';

interface EditIconProps {
    width?: number | string;
    height?: number | string;
    stroke?: string;
    strokeWidth?: number | string;
    className?: string;
}

const EditIcon = ({
    width = 24,
    height = 24,
    stroke = 'black',
    strokeWidth = 1.5,
    className = '',
}: EditIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M15 6L18 9M13 20H21M5 16L4 20L8 19L19.586 7.414C19.9609 7.03894 20.1716 6.53033 20.1716 6C20.1716 5.46967 19.9609 4.96105 19.586 4.586L19.414 4.414C19.0389 4.03906 18.5303 3.82843 18 3.82843C17.4697 3.82843 16.9611 4.03906 16.586 4.414L5 16Z"
                stroke={stroke}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default EditIcon;

